import './GlkHeader.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faBars } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/images/glk_member_area.svg';
import icon_logo from "../../assets/images/glk_member_area_mobile.svg";
import { useTranslation } from "react-i18next";
import i18n from '../../i18n/i18n.jsx';
import { useNavigate, useLocation } from "react-router-dom";
import { generateUserPin } from '../../pages/home/homeServices.jsx';
import { useContext, useState, useLayoutEffect } from 'react';
import { LoginContext } from '../../context/loginContext.jsx';
import LogoutPopup from './logoutPopup.jsx';
import TooltipWrapper from '../TooltipWrapper.jsx';
import UserPinModal from './userPinModal.jsx';

function RegistrationHeader(props) {
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
    const [show, setShow] = useState(false);
    const [userPin, setUserPin] = useState(null);
    const [showUserPinPopup, setShowUserPinPopup] = useState(false)

    const { t } = useTranslation();
    const languageCode = i18n.language;

    let navigate = useNavigate();
    let {
        loginData: {
            memberDetails,
            alias,
            accessToken,
        },
        dispatch,
        headerDispatch
    } = useContext(LoginContext);

    const token_lang = {
        language: languageCode,
        accessToken
    }

    const toggleMobileMenu = () => {
        setMobileMenuVisible(!mobileMenuVisible);
    };

    const logout = (e) => {
        localStorage.removeItem('accessToken');
        headerDispatch({ type: 'HOMEDETAILS', data: '' });
        headerDispatch({ type: 'MYPROFILE', data: '' });
        dispatch({ type: 'ACCESS_TOKEN', data: '' })
        dispatch({ type: 'LOGIN', data: null });
        dispatch({ type: 'MEMBER_DETAILS', data: null });
        dispatch({ type: 'IS_CONFIRM_MAIL_POPUP', data: true });
        navigate('/')
    }

    const location = useLocation();

    const getUserPin = (isShowPopup) => {
        generateUserPin(token_lang).then((response) => {
            if (response?.status === 200) {
                setUserPin(response.data);
                if (isShowPopup) setShowUserPinPopup(true)
            }
            else {
                setUserPin(null);
                if (isShowPopup) setShowUserPinPopup(true)
            }
        })
    }

    const closeUserPinPopup = () => { setShowUserPinPopup(false) }

    useLayoutEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }, [location.pathname]);

    function navigateToPage(path) {
        const pathUrl = {
            overview: '/',
        };
        navigate(pathUrl[path]);
    }

    return (
        <>
            <header className="app_header">
                <button className='main_logo' onClick={() => navigateToPage('overview')}>
                    <img className='full_logo' src={logo} alt="Gleichklang logo" />
                    <img className='small_logo' src={icon_logo} alt="Gleichklang Icon" />
                </button>

                <div id="headerButtons" className='header_bts'>
                    {location.pathname == '/registration' ?
                        <span className='greeting register_user'>
                            {memberDetails ?
                                <div
                                    onClick={() => getUserPin(true)}
                                    style={{ cursor: "pointer" }}
                                >
                                    {t('member.header.hello')} {alias}
                                </div>
                                :
                                null
                            }
                        </span> : null
                    }
                    <TooltipWrapper tooltipText={t('member.menubar.menu')} tooltipId="tooltip-menu" placement="bottom" modalVisible={mobileMenuVisible}>
                        <button className='toggle_menu' id="toggle_menu" aria-label={t('member.menubar.menu')} onClick={() => toggleMobileMenu()}>
                            <FontAwesomeIcon icon={faBars} />
                        </button>
                    </TooltipWrapper>

                    <TooltipWrapper tooltipText={t('member.header.logout')} tooltipId="tooltip-logout" placement="bottom" modalVisible={show}>
                        <button className='header_logout' aria-label={t('member.header.logout')} onClick={() => { setShow(true) }}>
                            <FontAwesomeIcon icon={faSignOutAlt} />
                        </button>
                    </TooltipWrapper>
                </div>
            </header>
            {show ?
                <LogoutPopup
                    isPreRegistration={false}
                    step={1}
                    show={show}
                    setShow={setShow}
                    logout={logout}
                    alias={alias}
                /> : ''}
            <UserPinModal
                showUserPinPopup={showUserPinPopup}
                showUserPinModal={showUserPinPopup}
                alias={alias}
                closeUserPinPopup={closeUserPinPopup}
                userPin={userPin}
            />
        </>
    )
}

export default RegistrationHeader;